import { CoralProductMeta, ProductMeta } from '@websrc/Basket/useProductMeta'
import { BasketState } from '@websrc/Typings/DanteBasket'
import React from 'react'
import { Helmet } from 'react-helmet'

import { priceStringToNumber } from '../Helpers/formatting'
import { isUnderTest } from '../Helpers/isUnderTest'
import { useHasConsent } from '../Hooks/useHasConsent/useHasConsent'
const fbqTrack = (event: string, type: string, params: Record<string, any>) => {
  if (isUnderTest()) return
  try {
    fbq(event, type, params)
  } catch (_error: unknown) {
    // Tracking not enabled
  }
}

export const fbPixel = {
  trackAddToCart: (productMeta: ProductMeta | CoralProductMeta, price: number) => {
    if (isUnderTest()) return
    const params: facebook.Pixel.AddToCartParameters = {
      content_ids: [productMeta.product_number],
      content_name: productMeta.name,
      content_type: 'type' in productMeta ? productMeta.type?.toLowerCase() : undefined,
      value: price,
      currency: 'USD',
    }

    fbqTrack('track', 'AddToCart', params)
  },
  trackViewContent: (meta: ProductMeta | CoralProductMeta, price: string) => {
    if (isUnderTest()) return
    const params: facebook.Pixel.ViewContentParameters = {
      content_category: '',
      content_ids: [meta.product_number],
      content_name: meta.name,
      content_type: 'type' in meta ? meta.type?.toLowerCase() : undefined,
      value: priceStringToNumber(price),
    }

    fbqTrack('track', 'ViewContent', params)
  },
  trackViewCoralContent: (meta: CoralProductMeta, price: string) => {
    if (isUnderTest()) return
    const params: facebook.Pixel.ViewContentParameters = {
      content_category: '',
      content_ids: [meta.product_number],
      content_name: meta.name,
      value: priceStringToNumber(price),
    }

    fbqTrack('track', 'ViewContent', params)
  },
  trackPurchase: (basketState: BasketState) => {
    if (isUnderTest()) return
    const params: facebook.Pixel.PurchaseParameters = {
      currency: 'USD',
      value: priceStringToNumber(basketState.subtotal),
      content_ids: basketState.items.map((item) => `${item.productNumber}`),
      num_items: basketState.items.length,
    }

    fbqTrack('track', 'Purchase', params)
  },
}

export const FacebookPixel = () => {
  const hasConsent = useHasConsent(['thirdparty'])
  if (isUnderTest()) return
  if (!hasConsent) {
    return null
  }

  const pixelId = '1238464073764043'

  return (
    <Helmet>
      <script type={'text/javascript'}>
        {`!function(f,b,e,v,n,t,s){
    if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', ${pixelId});
    fbq('track', 'PageView');`}
      </script>
      <noscript>
        {`<img height="1" width="1" style="display: none;" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`}
      </noscript>
    </Helmet>
  )
}
